import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';

function Home2() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <img src={Sol} />

          <h1>NOSSA MISSÃO</h1>
          <p>
            Somos um coletivo de psicanalistas dedicados a criar uma rede
            contínua de formação para psicanalistas. Nossa missão é oferecer
            palestras, seminários, minicursos, grupos de estudo e supervisões,
            além de estabelecer clínicas sociais acessíveis a todes, com o
            intuito de oferecer tratamento psíquico à população carente de nossa
            cidade.
          </p>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home2;
